var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "noOrderListIcon",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5117 14.7947C37.505 12.0395 36.581 9.60851 34.9111 7.94699C33.3268 6.37115 31.1663 5.53955 28.6631 5.53955H28.6245L28.0997 5.54126C27.8216 5.54217 27.5968 5.76811 27.5973 6.04619L27.6215 19.2114C27.6215 19.6163 27.43 19.996 27.1024 20.2328C26.7765 20.4697 26.3565 20.5369 25.9718 20.4126L21.6071 18.9947L17.2139 20.4445C17.0846 20.4882 16.9519 20.5084 16.8191 20.5084C16.5571 20.5084 16.3 20.4277 16.0816 20.2698C15.754 20.0329 15.5608 19.6532 15.5592 19.25L15.5446 6.07482C15.5443 5.79607 15.3178 5.5705 15.039 5.57137L14.4705 5.57315C9.16843 5.59163 5.61355 9.32627 5.62699 14.8652L5.65723 28.2044C5.66395 30.8756 6.49219 33.1705 8.05459 34.8438C9.65563 36.5557 11.8867 37.4595 14.5075 37.4595H14.5444L28.6984 37.4259C34.0005 37.4075 37.5537 33.6745 37.5436 28.1339L37.5117 14.7947Z",
    fill: "url(#paint0_linear_1624_25417)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0813 17.5073L21.2128 16.4741C21.4648 16.3901 21.7387 16.3884 21.9974 16.4724L25.102 17.4804L25.0795 6.0533C25.0788 5.77486 24.8527 5.54962 24.5742 5.55029L18.5712 5.56468C18.2931 5.56535 18.068 5.79114 18.0684 6.06925L18.0813 17.5073Z",
    fill: "url(#paint1_linear_1624_25417)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1624_25417",
    x1: 5.62695,
    y1: 5.53955,
    x2: 5.62695,
    y2: 37.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1624_25417",
    x1: 18.0684,
    y1: 5.55029,
    x2: 18.0684,
    y2: 17.5073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBox);
export default __webpack_public_path__ + "static/media/ic_box.ecd759ec.svg";
export { ForwardRef as ReactComponent };